
let aspects = [
    {plus: "Конкретний", minus: "Абстрактний", value: [1, 1, 1, 1, 0, 0, 0, 0], x: 1},
    {plus: "Статичний", minus: "Динамічний", value: [1, 0, 1, 0, 0, 1, 0, 1], x: 2},
    {plus: "Зовнішній", minus: "Внутрішній", value: [1, 0, 0, 1, 1, 0, 0, 1], x: 3},
    {plus: "Рушійний", minus: "Інерційний", value: [1, 0, 1, 0, 1, 0, 1, 0], x: 12},
    {plus: "Виконавчий", minus: "Цілестворюючий", value: [1, 0, 0, 1, 0, 1, 1, 0], x: 13},
    {plus: "Сприймаючий", minus: "Судящий", value: [1, 1, 0, 0, 0, 0, 1, 1], x: 23},
    {plus: "Залучений", minus: " Сторонній", value: [1, 1, 0, 0, 1, 1, 0, 0], x: 123}
];

let functions = [
    {plus: "Ментальна", minus: "Вітальна", value: [1, 1, 1, 1, 0, 0, 0, 0], x: 1},
    {plus: "Шаблонна", minus: "Ситуативна", value: [1, 0, 1, 0, 0, 1, 0, 1], x: 2},
    {plus: "Завантажена", minus: "Розвантажена", value: [1, 0, 0, 1, 1, 0, 0, 1], x: 3},
    {plus: "Акцептна", minus: "Продуктивна", value: [1, 0, 1, 0, 1, 0, 1, 0], x: 12},
    {plus: "Інертна", minus: "Контактна", value: [1, 0, 0, 1, 0, 1, 1, 0], x: 13},
    {plus: "Сильна", minus: "Слабка", value: [1, 1, 0, 0, 0, 0, 1, 1], x: 23},
    {plus: "Вербальна", minus: "Невербальна", value: [1, 1, 0, 0, 1, 1, 0, 0], x: 123}
];

let reinins = [
    {
        id: 0,
        name: "Інтуїт Сенсорик",
        value: [1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 0],
        plus: "Інтуїт",
        minus: "Сенсорик",
        x: 1
    },
    {
        id: 1,
        name: "Логік Етик",
        value: [1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1],
        plus: "Логік",
        minus: "Етик",
        x: 2
    }, {
        id: 2,
        name: "Статик Динамік",
        value: [1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0],
        plus: "Статик",
        minus: "Динамік",
        x: 3
    }, {
        id: 3,
        name: "Екстраверт Інтроверт",
        value: [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
        plus: "Екстраверт",
        minus: "Інтроверт",
        x: 4
    }, {
        id: 4,
        name: "Демократ Аристократ",
        value: [1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0],
        plus: "Демократ",
        minus: "Аристократ",
        x: 12
    }, {
        id: 5,
        name: "Розважливий Рішучий",
        value: [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        plus: "Розважливий",
        minus: "Рішучий",
        x: 13
    }, {
        id: 6,
        name: "Безпечний Передбачливий",
        value: [1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1],
        plus: "Безпечний",
        minus: "Передбачливий",
        x: 14
    }, {
        id: 7,
        name: "Веселий Серьозний",
        value: [1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
        plus: "Веселий",
        minus: "Серьозний",
        x: 23

    }, {
        id: 8,
        name: "Поступливий Упертий",
        value: [1, 1, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0],
        plus: "Поступливий",
        minus: "Упертий",
        x: 24
    }, {
        id: 9,
        name: "Ірраціонал Раціонал",
        value: [1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1],
        plus: "Ірраціонал",
        minus: "Раціонал",
        x: 34
    }, {
        id: 10,
        name: "Квестім Деклатім",
        value: [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1],
        plus: "Квестім",
        minus: "Деклатім",
        x: 123
    }, {
        id: 11,
        name: "Позитивіст Негативіст",
        value: [1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1],
        plus: "Позитивіст",
        minus: "Негативіст",
        x: 124
    }, {
        id: 12,
        name: "Тактик Стратег",
        value: [1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0],
        plus: "Тактик",
        minus: "Стратег",
        x: 134
    }, {
        id: 13,
        name: "Конструктивіст Емотивіст",
        value: [1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1],
        plus: "Конструктивіст",
        minus: "Емотивіст",
        x: 234
    }, {
        id: 14,
        name: "Процесор Результатер",
        value: [1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        plus: "Процесор",
        minus: "Результатер",
        x: 1234
    }];

let modelsA = [
    [7,2,0,5,1,4,6,3],[1,4,6,3,7,2,0,5],[4,1,3,6,2,7,5,0],[2,7,5,0,4,1,3,6],
    [4,6,3,1,2,0,5,7],[2,0,5,7,4,6,3,1],[0,2,7,5,6,4,1,3],[6,4,1,3,0,2,7,5],
    [0,5,7,2,6,3,1,4],[6,3,1,4,0,5,7,2],[3,6,4,1,5,0,2,7],[5,0,2,7,3,6,4,1],
    [3,1,4,6,5,7,2,0],[5,7,2,0,3,1,4,6],[7,5,0,2,1,3,6,4],[1,3,6,4,7,5,0,2]
];

let types = [
    {id: 0, code: "ІЛЕ", name: "Шукач", model: []},
    {id: 1, code: "СЕІ", name: "Посередник"},
    {id: 2, code: "ЕСЕ", name: "Ентузіаст"},
    {id: 3, code: "ЛІІ", name: "Аналітик"},
    {id: 4, code: "ЕІЕ", name: "Наставник"},
    {id: 5, code: "ЛСІ", name: "Інспектор"},
    {id: 6, code: "СЛЕ", name: "Маршал"},
    {id: 7, code: "ІЕІ", name: "Лірик"},
    {id: 8, code: "СЕЕ", name: "Політик"},
    {id: 9, code: "ІЛІ", name: "Критик"},
    {id: 10, code: "ЛІЕ", name: "Підприємець"},
    {id: 11, code: "ЕСІ", name: "Хранитель"},
    {id: 12, code: "ЛСЕ", name: "Адміністратор"},
    {id: 13, code: "ЕІІ", name: "Гуманіст"},
    {id: 14, code: "ІЕЕ", name: "Порадник"},
    {id: 15, code: "СЛІ", name: "Майстер"}
];




let subtypes = [
    {id: 0, name: "Домінантний", code: "D"},
    {id: 1, name: "Креативний", code: "C"},
    {id: 2, name: "Нормуючий", code: "N"},
    {id: 3, name: "Гармонызуючий", code: "H"}
];

let aspNames = ["ЧС","БС","БЛ","ЧЛ","ЧЕ","БЕ","БІ","ЧІ"	];
let aspAltNames = ["F","S","L","P","E","R","T","I"];
let funNames = ["Ф1","Ф2","Ф3","Ф4","Ф5","Ф6","Ф7","Ф8"];
let funAltNames = ["Базова","Творча","Рольова","Больова","Навіювана","Активаційна","Обмежувальна","Фонова"];


const groups = [{"name":"Установки на вид діяльності","reinins":[0,1,4],"groups":[{"name":"Дослідники","types":[0,3,9,10]},{"name":"Соціали","types":[1,2,8,11]},{"name":"Гуманітарії","types":[4,7,13,14]},{"name":"Керівники","types":[5,6,12,15]}]},{"name":"Біологічні стратегії","reinins":[0,2,5],"groups":[{"name":"Інфантили","types":[0,3,13,14]},{"name":"Дбайливі","types":[1,2,12,15]},{"name":"Віктіми","types":[4,7,9,10]},{"name":"Агресори","types":[5,6,8,11]}]},{"name":"Стимули до дії","reinins":[0,3,6],"groups":[{"name":"Унікальність","types":[0,4,10,14]},{"name":"Добробут","types":[1,5,11,15]},{"name":"Самоцінність","types":[3,7,9,13]},{"name":"Престиж","types":[2,6,8,12]}]},{"name":"Господарські ролі","reinins":[0,7,10],"groups":[{"name":"Вигадники","types":[0,3,4,7]},{"name":"Оброблювачі","types":[8,11,12,15]},{"name":"Договірники","types":[9,10,13,14]},{"name":"Добувачі","types":[1,2,5,6]}]},{"name":"Ставлення до ресурсів","reinins":[0,8,11],"groups":[{"name":"Захоплюються","types":[0,7,10,13]},{"name":"Набувають","types":[2,5,8,15]},{"name":"Попереджують","types":[3,4,9,14]},{"name":"Утримують","types":[1,6,11,12]}]},{"name":"Часова стратегія","reinins":[0,9,12],"groups":[{"name":"Новизни","types":[0,7,9,14]},{"name":"Минулого","types":[2,5,11,12]},{"name":"Майбутнього","types":[3,4,10,13]},{"name":"Теперішнього","types":[1,6,8,15]}]},{"name":"?","reinins":[0,13,14],"groups":[{"name":"","types":[0,4,9,13]},{"name":"","types":[1,5,8,12]},{"name":"","types":[3,7,10,14]},{"name":"","types":[2,6,11,15]}]},{"name":"Види взаємодії","reinins":[1,2,7],"groups":[{"name":"Систематизування","types":[0,3,5,6]},{"name":"Синхронізація","types":[1,2,4,7]},{"name":"Оптимізація","types":[9,10,12,15]},{"name":"Комунікація","types":[8,11,13,14]}]},{"name":"Стилі спілкування","reinins":[1,3,8],"groups":[{"name":"Діловий","types":[0,6,10,12]},{"name":"Душевний","types":[1,7,11,13]},{"name":"Холоднокровний","types":[3,5,9,15]},{"name":"Страсний","types":[2,4,8,14]}]},{"name":"Напрям самореалізації","reinins":[1,5,10],"groups":[{"name":"Творення","types":[0,3,12,15]},{"name":"Інтриги","types":[4,7,8,11]},{"name":"Керування","types":[5,6,9,10]},{"name":"Підтримка","types":[1,2,13,14]}]},{"name":"Відтінки поведінки","reinins":[1,6,11],"groups":[{"name":"Діячі","types":[0,5,10,15]},{"name":"Схиляючі","types":[2,7,8,13]},{"name":"Протидіючі","types":[3,6,9,12]},{"name":"Відвертаючі","types":[1,4,11,14]}]},{"name":"Стилі аргументації","reinins":[1,9,13],"groups":[{"name":"Реструктори","types":[0,6,9,15]},{"name":"Дотримачі","types":[2,4,11,13]},{"name":"Конструктори","types":[3,5,10,12]},{"name":"Дипломати","types":[1,7,8,14]}]},{"name":"?","reinins":[1,12,14],"groups":[{"name":"","types":[0,5,9,12]},{"name":"","types":[1,4,8,13]},{"name":"","types":[3,6,10,15]},{"name":"","types":[2,7,11,14]}]},{"name":"Темпераменти","reinins":[2,3,9],"groups":[{"name":"Гнучко-поворотливі","types":[0,6,8,14]},{"name":"Сприймаюче-адаптивні","types":[1,7,9,15]},{"name":"Врівноважено-стабільні","types":[3,5,11,13]},{"name":"Лінійно-напористі","types":[2,4,10,12]}]},{"name":"Образ особистості","reinins":[2,4,10],"groups":[{"name":"Індивідуалісти","types":[0,3,8,11]},{"name":"Елітарні","types":[4,7,12,15]},{"name":"Соціально-рольові","types":[5,6,13,14]},{"name":"Частково-ініціативні","types":[1,2,9,10]}]},{"name":"Інертність ірраціональності ?","reinins":[2,6,12],"groups":[{"name":"ЧІ?","types":[0,5,11,14]},{"name":"БІ?","types":[2,7,9,12]},{"name":"ЧС?","types":[3,6,8,13]},{"name":"БС?","types":[1,4,10,15]}]},{"name":"Інертність раціональних ?","reinins":[2,8,13],"groups":[{"name":"БЕ?","types":[0,6,11,13]},{"name":"ЧЕ?","types":[2,4,9,15]},{"name":"БЛ?","types":[3,5,8,14]},{"name":"ЧЛ?","types":[1,7,10,12]}]},{"name":"Стилі мислення (кільця ревізії)","reinins":[2,11,14],"groups":[{"name":"Причино-наслідкові","types":[0,5,8,13]},{"name":"Діалектичний","types":[1,4,9,12]},{"name":"Голографічний","types":[3,6,11,14]},{"name":"Вихровий","types":[2,7,10,15]}]},{"name":"Форма волі","reinins":[3,4,11],"groups":[{"name":"Ініціативні","types":[0,2,8,10]},{"name":"Виконавча","types":[5,7,13,15]},{"name":"Командуюча","types":[4,6,12,14]},{"name":"Сумнівна","types":[1,3,9,11]}]},{"name":"Контактність ?","reinins":[3,5,12],"groups":[{"name":"Відкриті","types":[0,2,12,14]},{"name":"Потайливі","types":[5,7,9,11]},{"name":"Конфліктні","types":[4,6,8,10]},{"name":"Миролюбні","types":[1,3,13,15]}]},{"name":"Впливовість формуюча ?","reinins":[3,7,13],"groups":[{"name":"Залучаючі","types":[0,2,4,6]},{"name":"Спокійні","types":[9,11,13,15]},{"name":"Маніпулятивні","types":[8,10,12,14]},{"name":"Ригідні","types":[1,3,5,7]}]},{"name":"Квадральні ролі","reinins":[3,10,14],"groups":[{"name":"Домінантні","types":[0,4,8,12]},{"name":"Нормуючі","types":[1,5,9,13]},{"name":"Креативні","types":[2,6,10,14]},{"name":"Гармонізуючі","types":[3,7,11,15]}]},{"name":"Квадри","reinins":[4,5,7],"groups":[{"name":"I Дитяча","types":[0,1,2,3]},{"name":"II Підлітки","types":[4,5,6,7]},{"name":"III Дорослі","types":[8,9,10,11]},{"name":"IV Похилі","types":[12,13,14,15]}]},{"name":"Мобілізація ?","reinins":[4,6,8],"groups":[{"name":"","types":[0,1,10,11]},{"name":"","types":[6,7,12,13]},{"name":"","types":[2,3,8,9]},{"name":"","types":[4,5,14,15]}]},{"name":"Стресостійкість","reinins":[4,9,14],"groups":[{"name":"Тормозні","types":[0,1,8,9]},{"name":"Нестійкі","types":[4,5,12,13]},{"name":"Тренуємі","types":[2,3,10,11]},{"name":"Стійкі","types":[6,7,14,15]}]},{"name":"?","reinins":[4,12,13],"groups":[{"name":"","types":[0,2,9,11]},{"name":"","types":[4,6,13,15]},{"name":"","types":[1,3,8,10]},{"name":"","types":[5,7,12,14]}]},{"name":"Стилі планування","reinins":[5,6,9],"groups":[{"name":"Хаотичні","types":[0,1,14,15]},{"name":"Варіативні","types":[6,7,8,9]},{"name":"Передбачувані","types":[2,3,12,13]},{"name":"Послідовні","types":[4,5,10,11]}]},{"name":"?","reinins":[5,8,14],"groups":[{"name":"","types":[0,1,12,13]},{"name":"","types":[4,5,8,9]},{"name":"","types":[2,3,14,15]},{"name":"","types":[6,7,10,11]}]},{"name":"Притензиційність","reinins":[5,11,13],"groups":[{"name":"Доброзичливі","types":[0,2,13,15]},{"name":"Незадоволені іншими","types":[4,6,9,11]},{"name":"Незадоволені собою","types":[1,3,12,14]},{"name":"Самовдоволені","types":[5,7,8,10]}]},{"name":"?","reinins":[6,7,14],"groups":[{"name":"","types":[0,1,4,5]},{"name":"","types":[8,9,12,13]},{"name":"","types":[10,11,14,15]},{"name":"","types":[2,3,6,7]}]},{"name":"?","reinins":[6,10,13],"groups":[{"name":"","types":[0,4,11,15]},{"name":"","types":[2,6,9,13]},{"name":"","types":[1,5,10,14]},{"name":"","types":[3,7,8,12]}]},{"name":"Вмотивованість","reinins":[7,8,9],"groups":[{"name":"Самореалізація","types":[0,1,6,7]},{"name":"Соціальний успіх","types":[8,9,14,15]},{"name":"Принципи","types":[2,3,4,5]},{"name":"Відповідальність","types":[10,11,12,13]}]},{"name":"?","reinins":[7,11,12],"groups":[{"name":"","types":[0,2,5,7]},{"name":"","types":[9,11,12,14]},{"name":"","types":[1,3,4,6]},{"name":"","types":[8,10,13,15]}]},{"name":"?","reinins":[8,10,12],"groups":[{"name":"","types":[0,7,11,12]},{"name":"","types":[2,5,9,14]},{"name":"","types":[1,6,10,13]},{"name":"","types":[3,4,8,15]}]},{"name":"Ресурсна стратегія","reinins":[9,10,11],"groups":[{"name":"Шукаючі","types":[0,7,8,15]},{"name":"Збираючі","types":[2,5,10,13]},{"name":"Відбираючі","types":[1,6,9,14]},{"name":"Оберігаючі","types":[3,4,11,12]}]}];

export { aspects, functions, reinins, types, subtypes, aspNames, funNames, aspAltNames, funAltNames, modelsA, groups };